
/*
 * Overlay
 */


// Global vars
/* global $biro_body */
var $biro_overlay = null;


/**
 * Open overlay
 *
 * @return void
 */
function biro_overlay_open() {

	// Only place overlay if it's not already there
	if ( $biro_overlay === null ) {

	// Place overlay, hidden, then fade in
	$biro_overlay = jQuery( '<div class="biro-overlay"></div>' );
	$biro_overlay
		.hide()
		.appendTo( $biro_body )
		.fadeIn( 200 );

	}

	// Add overlay listeners
	$biro_body.on( 'keydown', biro_overlay_close_esc );
	$biro_body.on( 'click', biro_overlay_close_click );

}


/**
 * Close overlay
 *
 * @return {void}
 */
function biro_overlay_close() {

	// Only proceed if overlay exists and not already closing
	if (
		$biro_overlay !== null &&
		! $biro_overlay.hasClass( 'is-closing' )
	) {

		// Add class, fade out, then remove
		$biro_overlay.addClass( 'is-closing' ).fadeOut(
			200,
			function() {
				$biro_overlay.remove();
				$biro_overlay = null;
			}
		);

		// Remove overlay listeners
		$biro_body.off( 'keydown', biro_overlay_close_esc );
		$biro_body.off( 'click', biro_overlay_close_click );

		// Trigger overlay close event
		$biro_body.trigger( 'biro:overlay:close' );

	}

}


/**
 * Has escape key been pressed to close?
 *
 * @param {object} e
 *
 * @return {void}
 */
function biro_overlay_close_esc( e ) {

	// Escape key?
	if ( e.key === 'Escape' ) {

		// Close overlay
		biro_overlay_close();

	}

}


/**
 * Has user clicked to close?
 *
 * @param {object} e
 *
 * @return {void}
 */
function biro_overlay_close_click( e ) {

	// Get click target
	var t = jQuery( e.target );

	// Overlay close if not clicking on menu...
	if (
		! t.hasClass( 'top-level-control' ) &&
		! t.parents( '.top-level-control' ).length
	) {

		// Close overlay
		biro_overlay_close();

	}

}
